
let version = 13;
let dbName = 'socketDb';

export const initDB = () => {
  return new Promise((resolve) => {
    let request = indexedDB.open(dbName, version);
    request.onupgradeneeded = () => {
      let db = request.result;

      // if the data object store doesn't exist, create it
      if (!db.objectStoreNames.contains('orders')) {
        console.log('Creating order store');
        db.createObjectStore('orders', { keyPath: 'id' });
      }
    };

    request.onsuccess = () => {
      let db = request?.result;
      version = db.version;
      // console.log('request.onsuccess - initDB', version);
      resolve(true);
    };

    request.onerror = () => {
      resolve(false);
    };
  });
};

export const addData = (storeName, data) => {
  return new Promise((resolve) => {
    let request = indexedDB.open(dbName, version);

    request.onsuccess = () => {
      // console.log('request.onsuccess - addData', data);
      let db = request.result;
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      store.put(data);
      resolve(data);
    };

    request.onerror = () => {
      const error = request.error?.message;
      if (error) {
        resolve(error);
      } else {
        resolve('Unknown error');
      }
    };
  });
};


export const getStoreData = (storeName) => {
  return new Promise((resolve) => {
    let request = indexedDB.open(dbName);

    request.onsuccess = () => {
      // console.log('request.onsuccess - getStoreData');
      let db = request.result;
      const tx = db.transaction(storeName, 'readonly');
      const store = tx.objectStore(storeName);
      const res = store.getAll();
      res.onsuccess = () => {
        resolve(res.result);
      };
    };
    request.onerror = () => {
      const error = request.error?.message;
      if (error) {
        resolve(error);
      } else {
        resolve('Unknown error');
      }
    };
  });
};

export const updateData = (storeName, data) => {
  return new Promise((resolve) => {
    let request = indexedDB.open(dbName, version);

    request.onsuccess = () => {
      // console.log('request.onsuccess - addData', data);
      let db = request.result;
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      store.put(data);
      resolve(data);
    };

    request.onerror = () => {
      const error = request.error?.message;
      if (error) {
        resolve(error);
      } else {
        resolve('Unknown error');
      }
    };
  });
};

export const deleteData = (storeName, data) => {
  return new Promise((resolve) => {
    let request = indexedDB.open(dbName, version);

    request.onsuccess = () => {
      console.log('request.onsuccess - deleteData', data);
      let db = request.result;
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      store.delete(data);
      resolve(data);
    };

    request.onerror = () => {
      const error = request.error?.message;
      if (error) {
        resolve(error);
      } else {
        resolve('Unknown error');
      }
    };
  });
};